module.exports = {"home":{"title":"NPI System","startDate":"Start Date","endDate":"End Date","user":"User","action":"Action","count":"Count","topActionByUser":"Top action by user","version":"Version","Hi":"Hi","Welcome to systems management":"Welcome to systems management","Manage your Tracker":"Manage your Tracker","Manage your Car reserve":"Manage your Car reserve","Manage your Project":"Manage your Project","Manage your systems":"Manage your systems"}}


//////////////////
// WEBPACK FOOTER
// ./src/wording/language/en/home.json
// module id = 728
// module chunks = 116